export default function CTASection() {
  return (
    <section className="relative h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20warm%20toned%20fashion%20accessories%20and%20lifestyle%20products%20flatlay%20composition%20on%20a%20rich%20cream%20marble%20surface%2C%20soft%20golden%20hour%20sunlight%20creating%20warm%20highlights%20and%20gentle%20shadows%2C%20elegant%20minimalist%20product%20photography%20with%20leather%20bags%20silk%20scarves%20and%20delicate%20jewelry%2C%20sophisticated%20neutral%20earthy%20palette%20with%20warm%20caramel%20honey%20and%20ivory%20tones%2C%20aspirational%20lifestyle%20aesthetic%20with%20editorial%20catalog%20quality%20and%20refined%20organic%20composition&width=1800&height=900&seq=cta-bg-product-v3&orientation=landscape"
          alt="Luxurious curated fashion product collection with bags, accessories, and lifestyle items"
          title="Superbuy Spreadsheet - Visit Our Main Store"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 w-full max-w-4xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 tracking-wide mb-5">
          VISIT OUR MAIN STORE
        </h2>
        <p className="font-body text-base md:text-lg text-background-50/85 mb-8 max-w-xl mx-auto leading-relaxed">
          Browse thousands of handpicked products, compare prices, and shop the best deals
          all in one place on Kaspreadsheet.
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-10 py-4 bg-foreground-950 text-background-50 font-label text-sm md:text-base font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 cursor-pointer whitespace-nowrap group"
        >
          <span className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
          </span>
          <span>SHOP AT KASPREADSHEET</span>
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </a>
      </div>
    </section>
  );
}